module.exports = __webpack_public_path__ + "media/sfx_corrcet_answer.fe967322.mp3";